import { Link } from "react-router-dom";
import { ArrowRight, Info, TriangleAlert } from "lucide-react";
import { ICONS } from "./icons";

export function Prose({ children }) { return <div className="prose">{children}</div>; }

export function Cards({ items, cols }) {
  return (
    <div className={`card-grid${cols === 2 ? " cols-2" : ""}`}>
      {items.map(item => {
        const Icon = ICONS[item.icon];
        return (
          <div key={item.title} className="info-card">
            {Icon && <span className="feature-icon"><Icon size={15} /></span>}
            <h3>{item.title}</h3>
            <p>{item.text}</p>
            {item.to && <Link to={item.to}>{item.linkLabel || "En savoir plus"}<ArrowRight size={12} /></Link>}
          </div>
        );
      })}
    </div>
  );
}

export function Table({ head, rows }) {
  return (
    <table className="kv-table">
      {head && <thead><tr>{head.map(h => <th key={h}>{h}</th>)}</tr></thead>}
      <tbody>{rows.map((r, i) => <tr key={i}>{r.map((c, j) => <td key={j}>{c}</td>)}</tr>)}</tbody>
    </table>
  );
}

export function Note({ children, kind = "warn" }) {
  const Icon = kind === "info" ? Info : TriangleAlert;
  return <div className={`note${kind === "info" ? " is-info" : ""}`}><Icon size={15} /><div>{children}</div></div>;
}
